import {RangeConfiguration} from '@hconnect/tuc-processes/fields/utils/types'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import {Typography, Box, IconButton} from '@mui/material'
import React, {useCallback} from 'react'

type HoseDischarge = {
  method: 'hose'
  hoseLength: number
}

type HoseLengthInputProps = {
  discharge: HoseDischarge
  hoseLengthConfig: RangeConfiguration
  onHoseLengthChange: (hoseLength: number) => void
}

export const HoseLengthInput: React.FC<HoseLengthInputProps> = ({
  discharge,
  hoseLengthConfig,
  onHoseLengthChange
}) => {
  const handleDecrease = useCallback(() => {
    const newLength = Math.max(hoseLengthConfig.min, discharge.hoseLength - hoseLengthConfig.step)
    onHoseLengthChange(newLength)
  }, [discharge.hoseLength, hoseLengthConfig.min, hoseLengthConfig.step, onHoseLengthChange])

  const handleIncrease = useCallback(() => {
    const newLength = Math.min(hoseLengthConfig.max, discharge.hoseLength + hoseLengthConfig.step)
    onHoseLengthChange(newLength)
  }, [discharge.hoseLength, hoseLengthConfig.max, hoseLengthConfig.step, onHoseLengthChange])

  return (
    <Box sx={{mb: 3}}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid #d1d9e0',
          borderRadius: '4px',
          padding: '8px'
        }}
      >
        <IconButton
          onClick={handleDecrease}
          sx={{
            width: '32px',
            height: '32px',
            color: '#52667a',
            padding: 0,
            minWidth: 'auto',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:focus': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:active': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:disabled': {
              color: 'rgba(82, 102, 122, 0.3)',
              backgroundColor: 'transparent'
            },
            '&.MuiIconButton-root': {
              backgroundColor: 'transparent'
            }
          }}
          data-test-id="hose-length-decrease"
        >
          <RemoveIcon sx={{fontSize: '16px'}} />
        </IconButton>

        <Box sx={{flex: 1, textAlign: 'center'}}>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#29333d'
            }}
          >
            {discharge.hoseLength} {hoseLengthConfig.uom}
          </Typography>
        </Box>

        <IconButton
          onClick={handleIncrease}
          sx={{
            width: '32px',
            height: '32px',
            color: '#52667a',
            padding: 0,
            minWidth: 'auto',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:focus': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:active': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            },
            '&:disabled': {
              color: 'rgba(82, 102, 122, 0.3)',
              backgroundColor: 'transparent'
            },
            '&.MuiIconButton-root': {
              backgroundColor: 'transparent'
            }
          }}
          data-test-id="hose-length-increase"
        >
          <AddIcon sx={{fontSize: '16px'}} />
        </IconButton>
      </Box>
    </Box>
  )
}
